import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  AdminCMSRoleApiRequest,
  DeleteAdminCMSRoleApiRequest,
  UpdateAdminCMSRoleApiRequest,
} from '@/data/payload/api/AdminCMSRoleRequest'
import { AdminCMSRolePresenter } from '@/app/ui/presenters/AdminCMSRolePresenter'
import { RoleCMSS } from '@/domain/entities/AdminCMSRole'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface AdminCMSRoleUI {
  AdminRoleCMSData: RoleCMSS
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'admincmsrole' })
class AdminCMSRoles extends VuexModule implements AdminCMSRoleUI {
  public AdminRoleCMSData = new RoleCMSS(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'id',
      type: 'asc',
    },
    search: '',
  }
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'roleName', sortable: true },
    { key: 'updatedAt', sortable: true },
    { key: 'createdAt', sortable: true },
    { key: 'actions', sortable: false },
  ]

  @Action
  public async getRoleCMSData() {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSRolePresenter)
    presenter
      .loadAdminCMSRole(this.paginationParam)
      .then((res: RoleCMSS) => {
        this.setLoading(false)
        this.setRoleCMSData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postAdminCMSRole(params: {
    roleName: string
    needSalesCode: boolean
    menu: any
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSRolePresenter)
    presenter
      .postAdminCMSRole(
        new AdminCMSRoleApiRequest(
          params.roleName,
          params.needSalesCode,
          params.menu
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Admin CMS Role',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getRoleCMSData()
      })
      .catch((error) => {
        this.setLoading(false)
      })
  }

  @Action
  public async deleteAdminCMSRole(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSRolePresenter)
    presenter
      .deleteAdminCMSRole(new DeleteAdminCMSRoleApiRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Admin CMS Role',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getRoleCMSData()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Admin CMS Role',
          message: 'Failed to delete',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async updateAdminCMSRole(params: {
    id: number
    roleName: string
    menu: any
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSRolePresenter)
    presenter
      .updateAdminCMSRole(
        new UpdateAdminCMSRoleApiRequest(
          params.id,
          params.roleName,
          params.menu
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Admin CMS Role',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getRoleCMSData()
      })
      .catch((error) => {
        this.setLoading(false)
      })
  }

  @Mutation
  private setRoleCMSData(admincmsrole: RoleCMSS) {
    this.AdminRoleCMSData = admincmsrole
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }

  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const AdminCMSRoleModule = getModule(AdminCMSRoles)
